// export const UploadServer = "https://api.crigging.shop/api/adminImageUpload";
// const ApiServer = "https://api.crigging.shop/graphql";
const ApiServer = "https://api.bluecompany.kr/graphql";
// const TestServer = "http://test.food-festa.com";

export const ServerIP = ApiServer;

export default ServerIP;
